<div class="card text-{{ textColor }} bg-{{ background }} h-100">
    <div class="card-body">
        <h4 class="card-title">{{ title | translate }}</h4>
        <i class="fa fa-3x fa-{{ icon }}"></i>
        <p class="card-text">{{ text | translate }}</p>
    </div>
</div>
